const MODULE_NAME = 'fulcrum/container/Project/NvqualSection'

const FETCH_START = MODULE_NAME + '/FETCH_START'
const FETCH_SUCCESS = MODULE_NAME + '/FETCH_SUCCESS'
const FETCH_ERROR = MODULE_NAME + '/FETCH_ERROR'

const TOGGLE_CARD_COLLAPSE = MODULE_NAME + '/TOGGLE_CARD_COLLAPSE'
const EXPAND_CARD = MODULE_NAME + '/EXPAND_CARD'

const NVQUAL_UPLOAD_DIALOG = MODULE_NAME + '/NVQUAL_UPLOAD_DIALOG'

const FETCH_NVQUAL_REPORT = MODULE_NAME + '/FETCH_NVQUAL_REPORT'
const FETCH_NVQUAL_REPORT_INITIAL = MODULE_NAME + '/FETCH_NVQUAL_REPORT_INITIAL'
const UPDATE_NVQUAL_REPORT_REVISION = MODULE_NAME + '/UPDATE_NVQUAL_REPORT_REVISION'
const UPDATE_NVQUAL_REVISION_NUMBER = MODULE_NAME + '/UPDATE_NVQUAL_REVISION_NUMBER'
const UPDATE_NVQUAL_STATUS_SOURCE = MODULE_NAME + '/UPDATE_NVQUAL_STATUS_SOURCE'
const POST_NVQUAL_STATUS = MODULE_NAME + '/POST_NVQUAL_STATUS'

const UPDATE_CURRENT_REVISION = MODULE_NAME + '/UPDATE_CURRENT_REVISION'

const CHANGE_CURRENT_REVISION = MODULE_NAME + '/CHANGE_CURRENT_REVISION'

const DOWNLOAD_FILES = MODULE_NAME + '/DOWNLOAD_FILES'

const CREATE_NVBUGS = MODULE_NAME + '/CREATE_NVBUGS'

const INIT_NVQUAL = MODULE_NAME + '/INIT_NVQUAL'

const UPDATE_PROJECT_NVQUAL_STATUS = MODULE_NAME + '/UPDATE_PROJECT_NVQUAL_STATUS'

const NVQUAL_REPORT_HEADER = [
  'name',
  'curRevNum',
  'file',
  'nvqualResultId',
  'user',
  'createdAt',
  'nvbugId',
  'comments',
]

const PASS_FINAL = 'Pass - Final Submission'
const PASS_INTER = 'Pass - Intermediate Milestone'
const FAIL = 'Fail'
const PENDING = 'Pending'

const STATUS_DROPDOWN_ORDER = [
  PASS_FINAL,
  PASS_INTER,
  FAIL,
  PENDING
]

export {
  MODULE_NAME,
  NVQUAL_UPLOAD_DIALOG,
  FETCH_NVQUAL_REPORT,
  UPDATE_NVQUAL_REPORT_REVISION,
  UPDATE_NVQUAL_REVISION_NUMBER,
  NVQUAL_REPORT_HEADER,
  UPDATE_NVQUAL_STATUS_SOURCE,
  POST_NVQUAL_STATUS,
  FETCH_NVQUAL_REPORT_INITIAL,
  UPDATE_CURRENT_REVISION,
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR,
  CHANGE_CURRENT_REVISION,
  DOWNLOAD_FILES,
  CREATE_NVBUGS,
  TOGGLE_CARD_COLLAPSE,
  EXPAND_CARD,
  INIT_NVQUAL,
  UPDATE_PROJECT_NVQUAL_STATUS,
  PASS_FINAL,
  PASS_INTER,
  FAIL,
  PENDING,
  STATUS_DROPDOWN_ORDER
}
